export default {
  setTags: (state, data) => {
    state.tags = data;
  }
};
